export const AUTH_ORIGIN =
  (import.meta.env.VITE_AUTH_ORIGIN as string | undefined) ??
  "https://auth.prismstreaming.com";
